import React from 'react';
import { Container } from '@mui/material';
import TaskAnalysisBuilder from '../components/TaskAnalysisBuilder';

const TaskAnalysisBuilderPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <TaskAnalysisBuilder />
    </Container>
  );
};

export default TaskAnalysisBuilderPage;